module.exports = __webpack_public_path__ + "media/newstyle/images/thumb-mini_de-f656977a2f87c1f159d90867ca6ce02c.jpg";